module.exports = __webpack_public_path__ + "media/images/home/concept_scene_3-d83e7a4f0db8c25090ed6e653dd168bf.png";